import {
  BellOutlined,
  SearchOutlined,
  SettingOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Avatar, Badge, Dropdown, Input } from 'antd';
import React from 'react';
import './index.less';
import { history, useModel } from '@umijs/max';

const CustomHeader: React.FC = () => {
  const { initialState }: any = useModel('@@initialState');
  const currUser = initialState?.currentUser;
  const userMenuItems: MenuProps['items'] = [
    {
      key: 'profile',
      label: 'Profile',
    },
    {
      key: 'settings',
      label: 'Settings',
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: 'Logout',
      onClick: () => {
        localStorage.removeItem('mdr_t');
        history.push('/user/login');
      },
    },
  ];

  return (
    <div className="custom-header">
      <div className="header-search">
        <Input
          placeholder="Search here"
          prefix={<SearchOutlined style={{ color: '#A0AEC0' }} />}
          className="search-input"
        />
      </div>

      <div className="header-actions">
        <Badge count={7} offset={[-5, 5]}>
          <div className="action-icon notification-icon">
            <BellOutlined style={{ fontSize: 20, color: '#2D3748' }} />
          </div>
        </Badge>

        <Badge count={1} offset={[-5, 5]}>
          <div className="action-icon settings-icon">
            <SettingOutlined style={{ fontSize: 20, color: '#2D3748' }} />
          </div>
        </Badge>

        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <div className="user-profile">
            <div className="user-info">
              <div className="user-name">{currUser?.name}</div>
              <div className="user-role">{currUser?.userType}</div>
            </div>
            <Avatar
              size={48}
              src="https://api.dicebear.com/7.x/avataaars/svg?seed=Adam"
              className="user-avatar"
            />
          </div>
        </Dropdown>
      </div>
    </div>
  );
};

export default CustomHeader;
